export const SELECTED_SHIPPING_OPTION_PREFIX = '__selected_shipping_option_'
export const SELECTED_SHIPPING_ADDRESS_ID_PREFIX =
    '__selected_shipping_address_id_'
export const CARRIER = 'carrier'
export const PREPAID_SHIPPING_OPTIONS = 'Prepaid shipping options'
export const PLACEMENT = 'shipping-section-quote-detail-checkout-summary-card'
export const FREIGHT_SHIPPING_WARNING =
    'This quote exceeds Fictiv’s standard shipping weight limit. To get you the best shipping estimate, proceed to “Begin checkout” and follow shipping instructions or select your own shipping account.'
export const INTL_PRIORITY_SHIPPING_MSG =
    'The average transit time for orders placed overseas exceeds the normal transit time shown above. Please expect additional 1-2 business days for your goods to arrive at the destination.'
export const UNABLE_TO_CALCULATE_SHIPPING =
    'Warning: Our service is unable to calculate a shipping cost at this time. You are still able to place your order. A Fictiv team member will follow up to collect additional shipping charges if applicable.'

export type ShippingSectionPropsType = {
    subTotalInCents?: number | null
    refetchShippingAddresses?: Function
    isQuoteOverseasShipping?: boolean
    isEligibleForFreeShipping: boolean
}

export type ParamsType = {
    id?: string
    quoteId?: string
    userId?: string
}
